export class Sorter {
  static hasProperty(obj: any, key: string) {
    return !!obj && Object.prototype.hasOwnProperty.call(obj, key);
  }

  static jpath(param: any, path: string) {
    const paths = path.split('.');
    let data = param;
    for (const key of paths) {
      data = data[key];
      if (!data) return null;
    }
    return data;
  }

  // function for dynamic sorting
  static compareByPath(path: string, order: boolean) {
    return (a: any, b: any) => {
      const aVal = this.jpath(a, path); // a['teacher']['full_name'];
      const bVal = this.jpath(b, path); //b['teacher']['full_name'];
      console.log('ab ', aVal, bVal);
      let comparison = 0;
      if (!aVal && !bVal) comparison = 1;
      if (!aVal) comparison = -1;
      if (!bVal) comparison = 1;
      if (aVal > bVal) comparison = 1;
      if (aVal < bVal) comparison = -1;
      return !order ? comparison * -1 : comparison;
    };
  }
}
